export function setCookie(name: string, value: string, days: number) {
  if (typeof document !== 'undefined') {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
}

export function getCookie(name: string) {
  if (typeof document !== 'undefined') {
    const value = `; ${document?.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return null;
  }
}

export function removeCookie(name: string) {
  if (typeof document !== 'undefined')
    document.cookie = name + '=; Max-Age=-99999999; path=/;';
}
